import {
    BasicAddExtraCurrencyCommand,
    BasicBackgroundComponent,
    BasicChangeCountryCommand,
    BasicChangeLanguageCommand,
    BasicCheckMaintenanceCommand,
    BasicConnectClientCommand,
    BasicConnectionFailedCommand,
    BasicConnectionTimeoutCommand,
    BasicConstants,
    BasicController,
    BasicDialogHandler,
    BasicExtensionResponseCommand,
    BasicGame,
    BasicInviteFriendCommand,
    BasicInviteFriendJsonCommand,
    BasicJoinedRoomCommand,
    BasicLayoutManager,
    BasicLoginJsonCommand,
    BasicModel,
    BasicOnClickMoreCurrencyCommand,
    BasicOpenForumCommand,
    BasicPrepareReconnectCommand,
    BasicRegisterDialogProperties,
    BasicRegisterJsonCommand,
    BasicSmartfoxClient,
    CommandController,
    EnvGlobalsHandler,
    GoodgameBitmapEngine,
    IEnvironmentGlobals,
    SmartfoxEvent,
    XMLInterfaceObject,
    XMLInterfaceObjectFactory,
    BasicStandardOkDialogProperties
} from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { Poker2Constants } from "./constants/Poker2Constants";
import { SFConstants } from "./constants/SFConstants";
import { Poker2ConnectionLostCommand } from "./controller/clientCommands/Poker2ConnectionLostCommand";
import { Poker2DestroyGameCommand } from "./controller/clientCommands/Poker2DestroyGameCommand";
import { Poker2InitalizeControllerCommand } from "./controller/clientCommands/Poker2InitalizeControllerCommand";
import { Poker2InitServerCommandsCommand } from "./controller/clientCommands/Poker2InitServerCommandsCommand";
import { Poker2LoginCommand } from "./controller/clientCommands/Poker2LoginCommand";
import { Poker2LogoutCommand } from "./controller/clientCommands/Poker2LogoutCommand";
import { Poker2ReconnectCommand } from "./controller/clientCommands/Poker2ReconnectCommand";
import { Poker2RegisterUserCommand } from "./controller/clientCommands/Poker2RegisterUserCommand";
import { Poker2ShowRegisterDialogCommand } from "./controller/clientCommands/Poker2ShowRegisterDialogCommand";
import { AvatarCreationEvent } from "./event/AvatarCreationEvent";
import { Poker2AchievementData } from "./model/components/Poker2AchievementData";
import { Poker2AvatarData } from "./model/components/Poker2AvatarData";
import { Poker2BuddyData } from "./model/components/Poker2BuddyData";
import { Poker2GiftData } from "./model/components/Poker2GiftData";
import { Poker2InventoryData } from "./model/components/Poker2InventoryData";
import { Poker2LobbyData } from "./model/components/Poker2LobbyData";
import { Poker2onTableData } from "./model/components/Poker2onTableData";
import { Poker2RankingData } from "./model/components/Poker2RankingData";
import { Poker2RegistrationData } from "./model/components/Poker2RegistrationData";
import { Poker2SessionData } from "./model/components/Poker2SessionData";
import { Poker2SharedObject } from "./model/components/Poker2SharedObject";
import { Poker2ShopData } from "./model/components/Poker2ShopData";
import { Poker2SitnGoData } from "./model/components/Poker2SitnGoData";
import { Poker2SocialData } from "./model/components/Poker2SocialData";
import { Poker2TournamentData } from "./model/components/Poker2TournamentData";
import { Poker2UserData } from "./model/components/Poker2UserData";
import { Poker2WodData } from "./model/components/Poker2WodData";
import { Poker2Model } from "./model/Poker2Model";
import { Poker2RegisterSocialDialog } from "./view/dialogs/registration/Poker2RegisterSocialDialog";
import { Poker2LayoutManager } from "./view/Poker2LayoutManager";
import { Poker2ChangeLanguageCommand } from "./controller/clientCommands/Poker2ChangeLanguageCommand";
import { Poker2AddExtraCurrencyCommand } from "./controller/commands/Poker2AddExtraCurrencyCommand";

import Event = createjs.Event;
import Ticker = createjs.Ticker;
import {Poker2PreloadEvent} from "./event/Poker2PreloadEvent";
import { ErrorCodes } from "./constants/shared/ErrorCodes";
import { Poker2WarningDialog } from "./view/dialogs/Poker2WarningDialog";

export class PokerGame extends BasicGame {

    public static STAGE_MOUSEOVER_TIME: number = 13;

    constructor(preloaderView: BasicBackgroundComponent) {
        super(preloaderView);
    }

    public onAddedToStage(): void {
        //logger.debug("onAddedToStage");

        //IMPORT CLASSES - DO NOT REMOVE
        //Poker2ImportConstants;

        this.setupConfigurations();

        super.onAddedToStage();
        this.stage.snapToPixelEnabled = true;
    }

    private setupConfigurations(): void {
        // allow smoothing in the BitmapEngine
        GoodgameBitmapEngine.instance.smoothing = false;
        // createjs.TextField.scaleCacheForTextfieldsWithFilters = false;
    }

    protected registerCommands(): void {
        CommandController.instance.registerCommand(BasicController.COMMAND_EXTENSION_RESPONSE, BasicExtensionResponseCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_INIT_SERVERCOMMANDS, Poker2InitServerCommandsCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_LOGIN, Poker2LoginCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_LOGOUT, Poker2LogoutCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_CHANGE_COUNTRY, BasicChangeCountryCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CHANGE_LANGUAGE, Poker2ChangeLanguageCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECTION_LOST, Poker2ConnectionLostCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_INITALIZE_CONTROLLER, Poker2InitalizeControllerCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_REGISTER_USER, Poker2RegisterUserCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_RECONNECT, Poker2ReconnectCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_OPEN_FORUM, BasicOpenForumCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_DESTROY_GAME, Poker2DestroyGameCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_SHOW_REGISTER_DIALOG, Poker2ShowRegisterDialogCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECT_CLIENT, BasicConnectClientCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_JOINED_ROOM, BasicJoinedRoomCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECTION_FAILED, BasicConnectionFailedCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECTION_TIMEOUT, BasicConnectionTimeoutCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_PREPARE_RECONNECT, BasicPrepareReconnectCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_LOGIN_JSON, BasicLoginJsonCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_REGISTER_USER_JSON, BasicRegisterJsonCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_INVITE_FRIEND, BasicInviteFriendCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_INVITE_FRIEND_JSON, BasicInviteFriendJsonCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CHECK_MAINTENANCE, BasicCheckMaintenanceCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_ADD_EXTRA_CURRENCY, Poker2AddExtraCurrencyCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_ON_CLICK_MORE_CURRENY, BasicOnClickMoreCurrencyCommand);
    }

    protected initializeGame(): void {
        Ticker.timingMode = Ticker.RAF; // we want RAF by default unless QA says otherwise
        Ticker.paused = true; // don't render or tick while initializing the game

        this.initModel();
        this.initView();
        this.initController();
        this.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectionEstablished));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECTION_LOST, this.bindFunction(this.onConnectionLost), false, -1);

        BasicController.getInstance().addEventListener("socialLoginFaild", this.bindFunction(this.onSocialLoginError));

        this.initAdditionalURLParameter();

        Ticker.paused = false;
        this.initialized.dispatch();
    }

    private onEnterFrame(event: Event): void {
        var now: number = Date.now();
        BasicDialogHandler.getInstance().showDialog(now);
    }

    protected onConnectionEstablished(event: SmartfoxEvent): void {
        if(this.env.isSSO){
            Poker2LayoutManager.getInstance().state = Poker2LayoutManager.STATE_SOCIAL_LOGIN;
        }
        else{
            if (!this.env.loginIsKeyBased && !BasicModel.smartfoxClient.userForcedDisconnect &&
                Poker2Model.localData.readLoginDataUsername() != null &&
                Poker2Model.localData.readLoginDataUsername() != "" &&
                Poker2Model.localData.readLoginDataPass() != null &&
                Poker2Model.localData.readLoginDataPass() != "") {
                // Game-Autologin
                // BasicModel.smartfoxClient.userForcedDisconnect = false;
                Poker2Model.userData.userName = Poker2Model.localData.readLoginDataUsername();
                Poker2Model.userData.loginPwd = Poker2Model.localData.readLoginDataPass();
                CommandController.instance.executeCommand(BasicController.COMMAND_LOGIN);
            }
            else {
                if (Poker2Model.localData.cookieExists) {
                    Poker2LayoutManager.getInstance().state = 2;
                }
                else {
                    Poker2LayoutManager.getInstance().state = BasicLayoutManager.STATE_AVATAR_CREATION;
                }
            }
        }
    }

    protected onConnectionLost(event: SmartfoxEvent): void {
        //TODO Pruefen ob STATE_REGISTRATION ueberhaupt noetig ist
        var layoutManager: Poker2LayoutManager = Poker2LayoutManager.getInstance();
        switch (layoutManager.currentState) {
            case BasicLayoutManager.STATE_AVATAR_CREATION:
            case BasicLayoutManager.STATE_REGISTRATION:
                break;
            default:
                this.reInitializGame();
                break;
        }
    }

    /**
     * Bei Fehlern ErrorPopUp anzeigen und WorldSelection wieder anzeigen (reconnect).
     * - SmartFoxConnection Faild
     * - VersionControl Faild
     * - SocialLogin Faild
     */
    private onSocialLoginError( e:Poker2PreloadEvent ):void {
        let title: string, copy: string;
        if (e.params && e.params.length > 0) {
            switch (e.params[ 0 ]) {
                case "connectionFaild":
                    title = BasicModel.languageData.getTextById( "generic_alert_connection_failed_title" );
                    copy = BasicModel.languageData.getTextById( "generic_alert_connection_failed_copy" );
                    break;
                case "connectionLost":
                    title = BasicModel.languageData.getTextById( "generic_alert_connection_lost_title" );
                    copy = BasicModel.languageData.getTextById( "generic_alert_connection_lost_copy" );
                    break;
                case 21:
                case 20:
                    title = BasicModel.languageData.getTextById( "generic_alert_bug" );
                    copy = BasicModel.languageData.getTextById( "generic_login_wronglogin" );
                    break;
                case 27:
                    title = BasicModel.languageData.getTextById( "generic_alert_information" );
                    copy = BasicModel.languageData.getTextById( "generic_login_banned" );
                    break;
                case 2:
                    title = BasicModel.languageData.getTextById( "generic_alert_bug" );
                    copy = BasicModel.languageData.getTextById( "errorcode_" + 98 );
                    break;
                default:
                    title = BasicModel.languageData.getTextById( "generic_versioncheck_error" );
                    copy = BasicModel.languageData.getTextById( "generic_versioncheck_errorcode_" + e.params[ 0 ] );
                    break;
            }
            Poker2LayoutManager.getInstance().showDialog(
                "Poker2WarningDialog",
                new BasicStandardOkDialogProperties( title, copy, this.bindFunction(this.onSocialLoginReconnect), BasicModel.languageData.getTextById( "generic_btn_okay" ))
            );
        }
    }

    private onSocialLoginReconnect(): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_RECONNECT);
    }

    private initModel(): void {
        var itemsXMLConfigJSON: any = BasicModel.basicLoaderData.appLoader.getLoaderData(BasicConstants.ITEM_XML_LOADER);
        BasicModel.basicLoaderData.appLoader.removeLoaderData(BasicConstants.ITEM_XML_LOADER);
        let configXML: XMLInterfaceObject = XMLInterfaceObjectFactory.CREATE_MAP_FROM_JSON(itemsXMLConfigJSON);

        BasicModel.smartfoxClient = new BasicSmartfoxClient();

        Poker2Model.sessionData = new Poker2SessionData();
        Poker2Model.giftData = new Poker2GiftData();
        Poker2Model.userData = new Poker2UserData();
        Poker2Model.wodData = new Poker2WodData(configXML);
        Poker2Model.localData = new Poker2SharedObject();
        Poker2Model.socialData = new Poker2SocialData();
        Poker2Model.lobbyData = new Poker2LobbyData();
        Poker2Model.itemShop = new Poker2ShopData();
        Poker2Model.buddyList = new Poker2BuddyData(this.stage.loaderInfo.parameters.buddylist);
        Poker2Model.inventoryData = new Poker2InventoryData();
        Poker2Model.avatarData = new Poker2AvatarData();
        Poker2Model.achievementData = new Poker2AchievementData(null);
        Poker2Model.onTableData = new Poker2onTableData();
        Poker2Model.onSitnGoData = new Poker2SitnGoData();
        Poker2Model.tournamentData = new Poker2TournamentData();
        Poker2Model.rankingData = new Poker2RankingData();
        Poker2Model.registrationData = new Poker2RegistrationData();

        Poker2Model.wodData.buildVoDatas();
    }

    private reInitializGame(): void {

        Poker2Model.sessionData = new Poker2SessionData();
        Poker2Model.giftData = new Poker2GiftData();
        Poker2Model.userData = new Poker2UserData();
        Poker2Model.localData = new Poker2SharedObject();
        Poker2Model.socialData = new Poker2SocialData();
        Poker2Model.lobbyData = new Poker2LobbyData();
        Poker2Model.itemShop = new Poker2ShopData();
        Poker2Model.buddyList = new Poker2BuddyData(this.stage.loaderInfo.parameters.buddylist);
        Poker2Model.inventoryData = new Poker2InventoryData();
        Poker2Model.avatarData = new Poker2AvatarData();
        Poker2Model.achievementData = new Poker2AchievementData(null);
        Poker2Model.onTableData = new Poker2onTableData();
        Poker2Model.onSitnGoData = new Poker2SitnGoData();
        Poker2Model.tournamentData = new Poker2TournamentData();
        Poker2Model.rankingData = new Poker2RankingData();

        Poker2Model.wodData.buildVoDatas();

    }

    private initView(): void {
        BasicLayoutManager.setLayoutManagerClass(Poker2LayoutManager);
        var layoutManager: Poker2LayoutManager = Poker2LayoutManager.getInstance();
        this.addChild(layoutManager);
        (window as any).gamestage = Poker2LayoutManager.getInstance().gameStage = this.stage;
        layoutManager.initialize(this.preloaderView);
    }

    protected onTick(props: createjs.TickerEvent): void {
        if (!Ticker.paused) {
            if(this.stage.tickEnabled) {
                this.stage.update(props);
            }
            Poker2LayoutManager.getInstance().renderStages(props);
        }
    }

    private initAdditionalURLParameter(): void {
        if (this.env.urlVariables.urlParams.has("ticker")) {
            let tickerType: number = parseInt(this.env.urlVariables.urlParams.get("ticker"));
            switch (tickerType) {
                case 2:
                    Ticker.timingMode = Ticker.RAF;
                    break;
                case 3:
                    Ticker.timingMode = Ticker.RAF_SYNCHED;
                    break;
                default:
                case 1:
                    Ticker.timingMode = Ticker.TIMEOUT;
                    break;
            }
        }

        if (this.env.urlVariables.urlParams.has("fps")) {
            // Ticker.setFPS( parseInt(this.env.urlVariables.urlParams.get("fps")) );
            let fps = parseInt(this.env.urlVariables.urlParams.get("fps"));
            if (fps > 0 && fps <= 60) {
                Ticker.framerate = fps;
            }
        }
    }

    private initController(): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_INITALIZE_CONTROLLER);
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicGame.prototype, "env").set.call(this, value);
    }
}
classImplementsInterfaces(PokerGame, "Container");
